import PlainDate from '@Domain/PlainDate';
import type { DossierPeriod } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Helpers/dossierPeriodOptions';

const subtractDays = (today: PlainDate, days: number): string => {
	const { year, month, day } = today;

	return PlainDate.fromCalendar(new Date(year, month - 1, day - days)).toApi();
};

/** Same day of the target month, clamped to its last day (31 May minus 3 months is 28 or 29 February). */
const subtractMonths = (today: PlainDate, months: number): string => {
	const { year, month, day } = today;
	const targetIndex = month - 1 - months;
	const lastDayOfTarget = new Date(year, targetIndex + 1, 0).getDate();

	return PlainDate.fromCalendar(new Date(year, targetIndex, Math.min(day, lastDayOfTarget))).toApi();
};

/** Calendar-day comparison on `YYYY-MM-DD` strings; a missing date only passes the `all` preset. */
const isWithinDossierPeriod = (date: PlainDate | null, period: DossierPeriod, today: PlainDate): boolean => {
	if (period === 'all') {
		return true;
	}

	if (date === null) {
		return false;
	}

	const day = date.toApi();
	const todayApi = today.toApi();

	switch (period) {
		case 'last7Days':
			return day >= subtractDays(today, 6) && day <= todayApi;
		case 'last30Days':
			return day >= subtractDays(today, 29) && day <= todayApi;
		case 'last3Months':
			return day >= subtractMonths(today, 3) && day <= todayApi;
		case 'last12Months':
			return day >= subtractMonths(today, 12) && day <= todayApi;
		case 'olderThanOneYear':
			return day < subtractMonths(today, 12);
	}
};

export default isWithinDossierPeriod;
